import { createAsyncThunk } from '@reduxjs/toolkit'
import { FoodCategoryGroup, storeManagementApi, userStoreManagementAPI, storeSpecialTypeApi } from '@services/api'

export const fetchStoreManagementList = createAsyncThunk(
  'storeManagement/fetchStoreManagementList',
  async (obj: { params?: TStoreManagementAPI.Params.Search }, { rejectWithValue }) => {
    try {
      const response = await storeManagementApi.fetchList(obj?.params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchStoreManagementDetail = createAsyncThunk(
  'storeManagement/fetchStoreManagementDetail',
  async (params: TStoreManagementAPI.Params.Detail, { rejectWithValue }) => {
    try {
      const response = await storeManagementApi.fetchSingle(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchBriefInfo = createAsyncThunk(
  'storeManagement/fetchBriefInfo',
  async (storeCD: string) => {
    try {
      const response = await storeManagementApi.fetchBriefInfo(storeCD)
      return response.data
    } catch (error: any) {
      return error.response.data
    }
  }
)

export const downloadExcel = createAsyncThunk(
  'storeManagement/downloadExcel',
  async (params: any) => {
    const response = await storeManagementApi.downloadExcel(params)
    return response
  }
)

export const uploadExcel = createAsyncThunk(
  'storeManagement/uploadExcel',
  async (data: FormData) => {
    const response = await storeManagementApi.uploadExcel(data)
    return response
  }
)

export const searchStore = createAsyncThunk(
  'storeManagement/searchStore',
  async (params: any) => {
    const response = await userStoreManagementAPI.searchList(params)
    return response.data
  }
)

export const getVideoCount = createAsyncThunk(
  'storeManagement/getVideoCount',
  async (params: any) => {
    const response = await storeManagementApi.getGoLiverVideoCount(params)
    return response.data
  }
)

export const transferVideos = createAsyncThunk(
  'storeManagement/transferVideos',
  async (params: any) => {
    const response = await storeManagementApi.transferGoLiverVideos(params)
    return response
  }
)

export const fetchFoodCategoryGroups = createAsyncThunk(
  'storeManagement/fetchFoodCategoryGroups',
  async () => {
    const response = await FoodCategoryGroup.fetchAllFoodCategoryGroups()
    return response.data
  }
)

export const getShopManagerToken = createAsyncThunk(
  'storeManagement/getShopManagerToken',
  async (params: any) => {
    const response = await storeManagementApi.getShopManagerToken(params)
    return response
  }
)

export const deleteNewMailOrder = createAsyncThunk(
  'storeManagement/deleteNewOrderProduct',
  async (id: string) => {
    const response = await storeManagementApi.deleteNewOrderProduct({ storeNewOrderProductId: id })
    return response
  }
)

// specialType
export const getSpecialTypeList = createAsyncThunk(
  'videoReport/getSpecialTypeList',
  async () => {
    const response = await storeSpecialTypeApi.fetchList()
    return response.data
  }
)

export const getSingleSpecialType = createAsyncThunk(
  'videoReport/getSingleSpecialType',
  async (id: string) => {
    const response = await storeSpecialTypeApi.fetchSingle(id)
    return response.data
  }
)

export const addSpecialType = createAsyncThunk(
  'videoReport/addSpecialType',
  async (params: any) => {
    const response = await storeSpecialTypeApi.create(params)
    return response
  }
)

export const updateSpecialType = createAsyncThunk(
  'videoReport/updateSpecialType',
  async (params: any) => {
    const response = await storeSpecialTypeApi.update(params)
    return response
  }
)

export const deleteSpecialType = createAsyncThunk(
  'videoReport/deleteSpecialType',
  async (id: string) => {
    const response = await storeSpecialTypeApi.delete(id)
    return response
  }
)

export const updateStoresSpecialType = createAsyncThunk(
  'videoReport/updateStoresSpecialType',
  async (params: any) => {
    const response = await storeSpecialTypeApi.updateStoresSpecialType(params)
    return response
  }
)

export const deleteStoreImage = createAsyncThunk(
  'videoReport/deleteStoreImage',
  async (params: any) => {
    const response = await storeManagementApi.deleteStoreImage(params)
    return response
  }
)

export const getStoreImages = createAsyncThunk(
  'videoReport/getStoreImages',
  async (id: string) => {
    const response = await storeManagementApi.getStoreImages(id)
    return response
  }
)
